/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface Hierarchy
 */
export interface Hierarchy  {
    /**
     * 
     * @type {number}
     * @memberof Hierarchy
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof Hierarchy
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Hierarchy
     */
    stage?: number;
    /**
     * 
     * @type {number}
     * @memberof Hierarchy
     */
    requestId?: number;
}

/**
 * Check if a given object implements the Hierarchy interface.
 */
export function instanceOfHierarchy(value: object): value is Hierarchy {
    return true;
}

export function HierarchyFromJSON(json: any): Hierarchy {
    return HierarchyFromJSONTyped(json, false);
}

export function HierarchyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Hierarchy {
    if (json == null) {
        return json;
    }
    return {
        
                  'entityId': json['entityId'] == null ? undefined : json['entityId'],
                  'name': json['name'] == null ? undefined : json['name'],
                  'stage': json['stage'] == null ? undefined : json['stage'],
                  'requestId': json['requestId'] == null ? undefined : json['requestId'],
    };
}

export function HierarchyToJSON(json: any): Hierarchy {
    return HierarchyToJSONTyped(json, false);
}

export function HierarchyToJSONTyped(value?: Hierarchy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entityId': value['entityId'],
        'name': value['name'],
        'stage': value['stage'],
        'requestId': value['requestId'],
    };
}


